module.exports = __webpack_public_path__ + "static/media/bglogin.819cc975.jpg";